import uniqueId from 'lodash/uniqueId';
import type { Engine } from './Engine';
import { Transform } from './Transform';
import type { Facet } from './facets/Facet';

export class Entity<P = {}> {

  id = uniqueId();
  transform: Transform;
  facets: Facet[];
  zIndex = 0;

  constructor(public props: P) {
    this.props = props;
    this.transform = new Transform();
    this.facets = this.createFacets(props);
    this.facets.forEach(f => { f.entity = this; });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  createFacets(props: P): Facet[] { return []; }

  getFacet<X, F extends Facet<X>>(Facet: { new (props: X): F }): F | undefined {
    return this.facets.find(f => f instanceof Facet) as F | undefined;
  }

  getFacets<X, F extends Facet<X>>(Facet: { new (props: X): F }): F[] {
    return this.facets.filter(f => f instanceof Facet) as F[];
  }

  addFacet<F extends Facet>(f: F, engine: Engine) {
    this.facets.push(f);
    f.entity = this;
    f.start(engine);
    return f;
  }

  removeFacet(f: Facet) {
    const i = this.facets.indexOf(f);
    if (i === -1) return;
    this.facets.splice(i, 1);
  }
}
